import React, { useEffect, useState, useRef } from "react";

const CardList = ({ cards, theme, color, noImage = false }) => {
  const [visibleCards, setVisibleCards] = useState([]);
  const observer = useRef();

  useEffect(() => {
    // Reset visible cards when cards change (navigation between pages)
    setVisibleCards([]);

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setVisibleCards((prev) => [
            ...new Set([...prev, entry.target.dataset.id]),
          ]);
        }
      });
    };

    observer.current = new IntersectionObserver(handleIntersection, {
      threshold: 0.2,
    });

    // Scope observation to only this instance's cards
    const elements = document.querySelectorAll(`.card-list.${theme} .card`);
    elements.forEach((element) => observer.current.observe(element));

    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, [theme, cards]); // Add cards as dependency to reset when cards change

  return (
    <div
      className={`card-list ${theme} grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 my-12`}
    >
      {cards.map(({ id, Component }) => (
        <div
          key={id}
          data-id={id}
          className={`card transition-all duration-700 ease-out transform ${
            visibleCards.includes(id)
              ? "visible opacity-100 translate-y-0"
              : "opacity-0 translate-y-8"
          }`}
        >
          <Component color={color} noImage={noImage} />
        </div>
      ))}
    </div>
  );
};

export default CardList;
